export default "__VITE_ASSET__0EX1qmUJ__"